module.exports = "<div ng-if=\"promoteTabletVersion.isVisible\" class=\"promote-tablet-version\"><div class=\"promote-tablet-version__heading\">Воспользуйтесь версией ЦИАН для планшетов</div>Мы рекомендуем использовать версию ЦИАН, разработанную специально под планшеты, для&nbsp;удобства&nbsp;и&nbsp;быстроты&nbsp;поиска.<button ng-click=\"promoteTabletVersion.onClick()\" class=\"promote-tablet-version__button\">Перейти к версии для планшетов</button><div ng-click=\"promoteTabletVersion.hide()\" class=\"cui-modal__close\"></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/serp/directives/promote-tablet-version/promote-tablet-version.jade
// module id = 925
// module chunks = 0